'use client';

import ProductBenefitsFaqTabs from '@/components/sections/Products/ProductBenefitsFaqTabs';
import type { ComponentProps } from 'react';

type ProductBenefitsFaqTabsShellProps = ComponentProps<typeof ProductBenefitsFaqTabs>;

export default function ProductBenefitsFaqTabsShell(props: ProductBenefitsFaqTabsShellProps) {
  return <ProductBenefitsFaqTabs {...props} />;
}
